import { render, staticRenderFns } from "./StakeSection.vue?vue&type=template&id=5b6662b5&scoped=true"
import script from "./StakeSection.vue?vue&type=script&lang=js"
export * from "./StakeSection.vue?vue&type=script&lang=js"
import style0 from "./StakeSection.vue?vue&type=style&index=0&id=5b6662b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6662b5",
  null
  
)

export default component.exports